import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-login-redirect-loading',
  templateUrl: './login-redirect-loading.html',
  styleUrls: ['./login-redirect-loading.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginRedirectLoadingComponent {
  constructor() {}
}